// extracted by mini-css-extract-plugin
module.exports = {"arrow":"index-module_arrow_NE22Z"};